export const baseUrl = "https://l65czxzj.apicdn.sanity.io/v2022-04-13/data/query/production";
export const newBaseUrl = "https://l65czxzj.api.sanity.io/v2022-04-13/data/query/current";
export const newBaseImageUrl = "https://cdn.sanity.io/images/l65czxzj/current/";
export const baseImageUrl = "https://cdn.sanity.io/images/l65czxzj/production/";